import PropTypes from 'prop-types';
import { Box, Checkbox } from '@mui/material';
import { Tag } from '@motusehf/web-ui-component-library/dist';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { formatToISKIfNotCurrencyClaim } from 'src/helpers/currencyClaim';
import getProduct from 'src/helpers/products';
import GavelIcon from '@mui/icons-material/GavelOutlined';
import BalanceIcon from '@mui/icons-material/Balance';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOnOutlined';

export default function MobileClaimCard({ claim, isFirst, isSelectable, isSelected, onSelect, isDefaultRegistered }) {
  const router = useRouter();
  const productDetails = getProduct(claim.product);
  const translatedProduct = productDetails?.name;
  const productColor = productDetails?.color;

  const handleClick = (e) => {
    if (e.target.type === 'checkbox') return;

    if (claim.claimId) {
      router.push(`/yfirlit/${claim.claimId}`);
    }
  };

  return (
    <Box onClick={handleClick} sx={{ paddingBottom: '25px', cursor: 'pointer' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: isFirst ? '20px 25px 20px 25px' : '0 25px 20px 25px',
          bgcolor: 'background.paper',
          borderRadius: 1,
          borderBottom: '1px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          {isSelectable && (
            <Checkbox
              sx={{
                transform: 'scale(1.5)',
                paddingLeft: '3px',
                paddingBottom: '12px',
              }}
              checked={isSelected}
              onChange={(e) => {
                e.stopPropagation();
                onSelect(e);
              }}
            />
          )}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
            <Box sx={{ fontWeight: 500, fontSize: '16px' }}>Gjalddagi</Box>
            <Box sx={{ fontSize: '16px' }}>{moment(claim.oldestUnpaidDueDate).format('DD.MM.YYYY')}</Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
            <Box sx={{ fontWeight: 500, fontSize: '16px' }}>Staða í innheimtu</Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
              {isDefaultRegistered && (
                <Tag
                  label="Skráning á vanskilaskrá"
                  color="rgba(207, 167, 176, 0.4)"
                  textColor="#88233a"
                  fontWeight={700}
                  iconSize="1.8rem"
                  height={32}
                  borderColor="#88233A"
                  hasBorder={true}
                  icon={<DoNotDisturbOnIcon sx={{ color: '#88233a' }} />}
                  iconPosition="left"
                />
              )}
              <Tag
                label={translatedProduct}
                color={productColor}
                fontWeight={700}
                responsive
                {...(translatedProduct === 'Upphaf löginnheimtu' && {
                  icon: <BalanceIcon sx={{ color: '#ffffff' }} />,
                  textColor: '#ffffff',
                  iconPosition: 'right',
                })}
                {...(translatedProduct === 'Löginnheimta' && {
                  icon: <GavelIcon sx={{ color: '#ffffff' }} />,
                  textColor: '#ffffff',
                  iconPosition: 'right',
                })}
              />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
            <Box sx={{ fontWeight: 500, fontSize: '16px' }}>Málanúmer</Box>
            <Box sx={{ fontSize: '16px' }}>{claim.claimNumber}</Box>
          </Box>
          {(claim.postponedUntilDate && moment().diff(moment(claim.postponedUntilDate)) < 0) ||
          claim.agreementStatus !== 'None' ||
          claim.isInBookingProcess ||
          (claim.isOpen && !claim.isInBookingProcess && claim.paymentBlockingClaims.length > 0) ? (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Box sx={{ fontWeight: 500, fontSize: '16px' }}></Box>
              <Box sx={{ fontSize: '16px' }}>
                {claim.postponedUntilDate &&
                  moment().diff(moment(claim.postponedUntilDate)) < 0 &&
                  `Greiðist fyrir ${moment(claim.postponedUntilDate).format('DD. MMMM YYYY')}`}
                {claim.agreementStatus !== 'None' && 'Í greiðsludreifingu'}
                {claim.isInBookingProcess && 'Greiðsla í vinnslu'}
                {claim.isOpen && !claim.isInBookingProcess && claim.paymentBlockingClaims.length > 0 && (
                  <Box sx={{ mt: '3px', fontSize: '16px' }}>
                    Þú þarft að greiða mál{' '}
                    <Link
                      href={`/yfirlit/${claim.paymentBlockingClaims[0].claimId}`}
                      style={{ textDecoration: 'underline' }}
                    >
                      {claim.paymentBlockingClaims[0].claimNumber}
                    </Link>{' '}
                    fyrst
                  </Box>
                )}
              </Box>
            </Box>
          ) : null}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ fontWeight: 500, fontSize: '16px' }}>Til greiðslu</Box>
            <Box sx={{ fontSize: '16px' }}>{formatToISKIfNotCurrencyClaim(claim.product, claim.totalRemaining)}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

MobileClaimCard.propTypes = {
  claim: PropTypes.object.isRequired,
  isFirst: PropTypes.bool.isRequired,
  isSelectable: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  isDefaultRegistered: PropTypes.bool,
};
